export default __webpack_public_path__ + "38ad52501b43f3389ee2f3830f585b8b.webp";